// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3F7An","content":"styles_content__3AoKb","tableWrap":"styles_tableWrap__2mWaK"};